// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"articles_scrollbar__2h-Q1"};